import axios from 'axios';
import { of } from 'rxjs';
import { AnsibleBoolean } from '../../core/interfaces/ansible-config';
import { CLIENTS, TESTIMONIALS } from '../constants/testimonials';


export function useFeaturedCustomers() {
  const getFeaturedCustomers = () => {


    return {
      customers: CLIENTS,
    };



  };

  return {
    getFeaturedCustomers
  };
}
